import { FilterFieldValue } from '../../covance-filter/covance-filter.models';
import { CovanceFilter } from '../../covance-filter/covance-filter';
import { Injectable } from '@angular/core';
import { Observable, combineLatest, of, merge, ConnectableObservable, Subscription } from 'rxjs';
import { switchMap, map, filter, refCount, publishReplay, flatMap, tap } from 'rxjs/operators';
import { LabTestResult } from '../../lab-test-results';
import { SponsorRouteData } from '../sponsor-route-data';
import { LabResultsFilterStorage } from './lab-results-filter-storage';
import { ActivatedRoute, Params } from '@angular/router';
import { SponsorLabResultsStorage } from './sponsor-lab-results-storage';
import { routeParams } from '../../shared/route-helpers';
import { UnitStorage } from '../../user/unit-storage';

@Injectable()
export class LabResultsDataStorage {

    public get labTestsData(): Observable<LabTestResult[]> {
        if (!this.testsData) {
            const loadData$ =
                this.route.params
                    .pipe(
                        map<Params, string | undefined>((p) => p[routeParams.zcTestCode]),
                        filter(t => !!t),
                        switchMap(t => this.loadLabTestsData(t)),
                        tap(results => {
                            if (!results) {
                                return;
                            }
                            this.testsDataSnapshotDictionary = {};
                            results.forEach(res => this.testsDataSnapshotDictionary[res.labTestId] = res);
                        }),
                        publishReplay(1),
                        refCount()
                    );

            const filterredData$ = this.filterDefs
                .pipe(
                    flatMap(filters => {
                        return this.covanceFilter.getFilteredData(loadData$, filters);
                    }));

            this.testsData = combineLatest([filterredData$, this.unitStorage.currentUnit])
                .pipe(
                    map(([results, unit]) => {
                        let result: LabTestResult[] = null;
                        if (results) {
                            result = results.map(r => {
                                r.showResultsInSI = unit.isSiUnit;
                                return r;
                            });
                        }
                        return result;
                    }),
                    publishReplay(1)
                ) as ConnectableObservable<LabTestResult[]>;
            this.connection = this.testsData.connect();
        }

        return this.testsData;
    }

    public testsDataSnapshotDictionary: { [index: number]: LabTestResult } = {};
    private connection: Subscription;

    private testsData: ConnectableObservable<LabTestResult[]>;

    private filterDefs: Observable<FilterFieldValue[]>;

    constructor(
        private readonly routeData: SponsorRouteData,
        private readonly unitStorage: UnitStorage,
        private readonly covanceFilter: CovanceFilter,
        private readonly route: ActivatedRoute,
        private readonly sponsorLabResultsStorage: SponsorLabResultsStorage,
        filterStorage: LabResultsFilterStorage
    ) {
        this.filterDefs = filterStorage.trendsFilterFields;
    }

    public ngOnDestroy(): void {
        this.connection.unsubscribe();
    }

    private loadLabTestsData(zcTestCode: string): Observable<LabTestResult[]> {
        return merge(of(null), this.sponsorLabResultsStorage.loadLabTestsData(this.routeData.snapshot.selectedStudy, zcTestCode));
    }
}
